import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useUsers } from '../context/UserContext';

const ProjectAccessGuard = ({ children }) => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const { user } = useUsers();

  useEffect(() => {
    if (!user) return;

    const requestedId = parseInt(projectId, 10);
    const allowedProjectIds = user.roles
      .map(role => role?.projectId)
      .filter(id => id !== null);

    // Redirect only if the requested projectId is NOT the assigned projectId
    if (!allowedProjectIds.includes(requestedId) && !allowedProjectIds.includes(0)) {
      const fallbackId = allowedProjectIds[0] ?? 0;
      if (requestedId !== fallbackId) {
        navigate(`/projects/${fallbackId}`, { replace: true });
      }
    }
  }, [projectId, user, navigate]);

  return children;
};

export default ProjectAccessGuard;
